import { Branding } from '@/src/lib/utils/branding.types.ts';
import { LogoConfig } from '@/src/app/components/Logo/logo.types.ts';

export const logoClaimConfig: Record<Branding, LogoConfig> = {
  [Branding.TURCK_BANNER]: {
    path: '/assets/logo-turck-banner.svg',
    className: 'h-10 w-auto',
    name: 'Turck Banner',
    intrinsicWidth: 274,
  },
  [Branding.DEFAULT]: {
    path: '/assets/logo_claim.svg',
    className: 'h-auto w-56 lg:w-64',
    name: 'Turck',
    intrinsicWidth: 508,
  },
};

export const logoConfig: Record<Branding, LogoConfig> = {
  [Branding.TURCK_BANNER]: {
    path: '/assets/logo-turck-banner.svg',
    className: 'h-8 w-auto',
    name: 'Turck Banner',
    intrinsicWidth: 410,
    intrinsicHeight: 41,
  },
  [Branding.DEFAULT]: {
    path: '/assets/logo_blank.svg',
    className: 'h-8 w-48',
    name: 'Turck',
    intrinsicWidth: 508,
    intrinsicHeight: 52,
  },
};
